import { render, staticRenderFns } from "./publicCourse.vue?vue&type=template&id=96d15222&scoped=true"
import script from "./publicCourse.vue?vue&type=script&lang=ts"
export * from "./publicCourse.vue?vue&type=script&lang=ts"
import style0 from "./publicCourse.vue?vue&type=style&index=0&id=96d15222&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d15222",
  null
  
)

export default component.exports